import React, { Component } from 'react'
import { css } from 'emotion'
import { CFView, Text } from 'components'

class PaintedButtonView extends Component {
  render() {
    const { className, disabled, label } = this.props
    const classNames = css(
      disabled ? styles.disabled : styles.button,
      className
    )
    return (
      <CFView center className={classNames}>
        <Text painting h2 white disabled={disabled}>
          {label}
        </Text>
      </CFView>
    )
  }
}

const styles = {
  button: css({
    width: '20rem',
    height: '4rem',
    background: 'black',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  }),
  disabled: css({
    paddingLeft: '4rem',
    paddingRight: '4rem',
    height: '4rem',
    background: 'rgba(0,0,0,0.4)',
    cursor: 'pointer',
  }),
}

export default PaintedButtonView
